import React from 'react';
import t from 'prop-types';

function getMaxFactor(config) {
  var aumentoZoom = config.aumento || 0;
  var multiplicadorZoom = config.multiplicador || 1;
  var pasosZoom = config.maxPasos || 0;
  var maxFactor = 100;

  for (var i = 0; i < pasosZoom; i++) {
    maxFactor = multiplicadorZoom * maxFactor + aumentoZoom;
  }

  return maxFactor;
}

function getMinFactor(config) {
  var aumentoZoom = config.aumento || 0;
  var multiplicadorZoom = config.multiplicador || 1;
  var pasosZoom = config.minPasos || 0;
  var minFactor = 100;

  for (var i = 0; i < pasosZoom; i++) {
    minFactor = (minFactor - aumentoZoom) / multiplicadorZoom;
  }

  return minFactor;
}

var ConsolaLupa = function ConsolaLupa(_ref) {
  var factorActual = _ref.factorActual,
      configVentana = _ref.configVentana,
      onZoomMas = _ref.onZoomMas,
      onZoomInicial = _ref.onZoomInicial,
      onZoomMenos = _ref.onZoomMenos;
  return React.createElement('div', {
    className: 'lupa'
  }, React.createElement('div', {
    className: 'zoomMas' + (factorActual === getMaxFactor(configVentana) ? ' desactivado' : ''),
    onClick: onZoomMas
  }), React.createElement('div', {
    className: 'zoomInicial' + (factorActual === 100 ? ' desactivado' : ''),
    onClick: onZoomInicial
  }), React.createElement('div', {
    className: 'zoomMenos' + (factorActual === getMinFactor(configVentana) ? ' desactivado' : ''),
    onClick: onZoomMenos
  }));
};

ConsolaLupa.propTypes = process.env.NODE_ENV !== "production" ? {
  factorActual: t.number,
  configVentana: t.object,
  onZoomMas: t.func,
  onZoomInicial: t.func,
  onZoomMenos: t.func
} : {};
export default ConsolaLupa;